import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 COLOR

    Tres formas de elegir el mismo valor: la muestra (abre el selector
    del sistema), el hex escrito a mano, y los atajos de la paleta.

    Los atajos por defecto salen de TUS variables, así que ofrecen la
    paleta del proyecto y no un arcoíris genérico.
*/

const DEFAULT_SWATCHES = [
    'var(--LS__app_priv_accent)',
    'var(--LS__app_priv_ok)',
    'var(--LS__app_priv_info)',
    'var(--LS__app_priv_warn)',
    'var(--LS__app_priv_danger)',
    'var(--LS__app_accent_violet)',
    'var(--LS__app_priv_clear)',
    'var(--LS__app_priv_text_main)',
];

export const FieldColor = ({
    id, name, label, hint, error,
    value = '#2a8f5f', onChange,
    swatches = null, showSwatches = true,
    isDisabled = false, span = 1,
}) => {

    const onPick = (color) => onChange?.({ target: { name: name ?? id, value: color } });

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__color`}>

                <label className={`${BLOCK}__color_preview`} style={{ background: value }}>
                    <input id={DOM_ID} data-field={name ?? id} name={name ?? id} type="color"
                        className={`${BLOCK}__color_native`}
                        value={value} onChange={onChange} disabled={isDisabled} />
                </label>

                <input type="text" name={DOM_NAME} className={`${BLOCK}__input ${BLOCK}__color_hex`}
                    value={value} onChange={onChange} disabled={isDisabled}
                    placeholder="#000000" maxLength={7}
                    autoComplete={FIELD_AUTOCOMPLETE_OFF}
                    aria-label="Código hexadecimal" />

            </div>

            {
                showSwatches && (
                    <div className={`${BLOCK}__swatches`}>
                        {
                            (swatches ?? DEFAULT_SWATCHES).map((color) => (
                                <button key={color} type="button" className={`${BLOCK}__swatch`}
                                    style={{ background: color }} title={color}
                                    disabled={isDisabled} onClick={() => onPick(color)} />
                            ))
                        }
                    </div>
                )
            }

        </FieldShell>
    );
};
